import { render, staticRenderFns } from "./RecommendCaseModalComponent.vue?vue&type=template&id=14f45cb1&"
import script from "./RecommendCaseModalComponent.vue?vue&type=script&lang=js&"
export * from "./RecommendCaseModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports